import { ChangeDetectionStrategy, Component, ElementRef, inject, Inject, Input, ViewChild } from '@angular/core';
import { LocalDateAdapter } from '@core/localization/local-date-adapter';
import { GetDbtimeResponse } from '@api/models/TariffEditorApi/Contract/get-dbtime-response';
import { addMinutes, format, parseISO } from 'date-fns';


/**
 * Clock in nav-bar
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-clock',
    templateUrl: './clock.component.html',
    styleUrls: ['./clock.component.scss'],
    standalone: true,
})
export class ClockComponent {
    readonly #dateAdapter: LocalDateAdapter = inject(LocalDateAdapter);
    /**
     * Ref object
     */
    @ViewChild('clock', { static: true }) clock: ElementRef;

    public readonly format: string = this.#dateAdapter.format.time;

    private minIncrement: number = 0;
    private intervalId: number;

    constructor(
        @Inject('window') private window: Window,
    ) {
    }

    @Input()
    public set time(time: GetDbtimeResponse) {
        if (time) {
            this.showTime(time);

            if (this.intervalId) {
                this.window.clearInterval(this.intervalId);
            }

            this.intervalId = this.window.setInterval(() => {
                this.showTime(time);
            }, 60000);
        }
    }

    private showTime(time: GetDbtimeResponse): void {
        this.clock.nativeElement.innerHTML = time?.localtime
            ? format(addMinutes(parseISO(time.localtime), this.minIncrement), this.format)
            : '';

        this.minIncrement++;
    }
}
